<script>
    export let ourcafeImages = [];
</script>

<div class="home__ourcafe home-ourcafe">
    <div class="header">
        <h1 class="header__heading heading heading_level_1">Our Cafe</h1>
        <span class="header__text text text_large">오늘 하루를 특별하게 해주는 한잔 <br /> 커피 멘토는 고품질 음료와 프리미엄 인테리어로 <br /> 24시간 운영되는 프리미엄 카페입니다.</span>
    </div>

    <ul class="home-ourcafe__list">
        {#each ourcafeImages as img}
        <li class="home-ourcafe__item"><img class="home-ourcafe__img" src="{img.src}" alt="{img.alt}" /></li>
        {/each}
        {#each ourcafeImages as img}
        <li class="home-ourcafe__item"><img class="home-ourcafe__img" src="{img.src}" alt="{img.alt}" /></li>
        {/each}
    </ul>
</div>

<style>
  .home-ourcafe {
    background: var(--secondary);
    width: 100vw;
    overflow: hidden;
  }
  .home-ourcafe > .header {
    max-width: 500px;
    margin: 0 auto;
  }
  .home-ourcafe__list {
    animation: slideLeft calc(3s * 5) linear infinite;
    background: var(--secondary);
    width: max-content;
    display: flex;
    gap: 80px;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 100px 40px 0 40px;
    margin: 0;
    white-space: nowrap;
    word-break: keep-all;
  }
  .home-ourcafe__list:hover {
    /*animation-play-state: paused;*/
  }

  @keyframes slideLeft {
    from {transform: translate(0px, 0px);}
    to {transform: translate(calc((360px + 80px) * -5), 0px); }
  }

  .home-ourcafe__list::-webkit-scrollbar {
    display: none;
  }
  /*.home-ourcafe__list .home-ourcafe__item:active {*/
  /*  transform: scale(1.1);*/
  /*}*/
  .home-ourcafe__item {
    position: relative;
    flex-shrink: 0;
    width: 360px;
    height: 360px;
    /*border-radius: 50%;*/
    /*overflow: hidden;*/
    transform-origin: center center;
    transform: scale(1);
    transition: 0.3s ease-out;
    user-select: none;
  }
  .home-ourcafe__item:before {
    content: '';
    position:absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: transparent;
    z-index: 10;
  }
  .home-ourcafe__img {
    position: relative;
    z-index: 1;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  @media screen and (min-width: 900.1px) {
    .home-ourcafe__item:hover {
      transform: scale(1.05);
    }
  }

  @media screen and (max-width: 900px) {
    @keyframes slideLeft {
      from {transform: translate(0px, 0px);}
      to {transform: translate(calc((280px + 40px) * -5), 0px); }
    }

    .home-ourcafe__item:active {
      transform: scale(1.05);
    }

    .home-ourcafe__list {
      gap: 40px;
      padding: 60px 20px 0 20px;
    }

    .home-ourcafe__item {
      width: 280px;
      height: 280px;
    }
  }
</style>
